import { Col, Row, Typography } from "@codat/orchard-ui";
import { Product } from "api/schema/productsSchema";
import React, { useMemo } from "react";

import { GettingStartedCard } from "components/GettingStartedCard";

import { getCardInfo } from "./getCardInfo";
import styles from "./GettingStartedSection.module.scss";

export interface GettingStartedSectionProps {
  product: Product | undefined;
  title: "gettingStarted" | "productName" | "hide";
  displaySubtext: boolean;
}

export const GettingStartedSection = ({
  product,
  title,
  displaySubtext,
}: GettingStartedSectionProps) => {
  const productCards = getCardInfo(product);
  const titleText = useMemo(() => {
    switch (title) {
      case "gettingStarted":
        return "Getting started";
      case "productName":
        return product?.name.replace(" V1", ""); // Remove V1 suffix from titles. TODO: delete once this logic has been moved to the backend
      case "hide":
        return undefined;
    }
  }, [title, product]);

  const testId = product
    ? `getting-started-section-${product.productId}`
    : "getting-started-section";
  return (
    <div data-testid={testId}>
      <Row>
        <Col size={12}>
          {titleText && (
            <Typography as="h2" variant="heading_lg" noMargin>
              {titleText}
            </Typography>
          )}
          {displaySubtext && (
            <Typography
              as="p"
              variant="body_md"
              className={styles.description}
              noMargin
            >
              Useful resources to help understand and get started with
              Codat&apos;s products.
            </Typography>
          )}
        </Col>
      </Row>
      <Row>
        {productCards.map((productCard) => {
          return (
            <Col key={productCard.testId} size={4}>
              <GettingStartedCard
                key={productCard.headerText}
                {...productCard}
              />
            </Col>
          );
        })}
      </Row>
    </div>
  );
};
